<div class="iframe-container">
  <div class="iframe-content">

    <nav class="nav-bar">
      <button mat-button
        class="lnk"
        id="iframe-back-btn"
        (click)="goBack()">
        {{ 'default.back' | blah }}
        <mat-icon>keyboard_backspace</mat-icon>
      </button>

      <button mat-button
        class="lnk"
        id="iframe-close-btn"
        (click)="close()">
        {{ 'default.close' | blah }}
        <mat-icon>close</mat-icon>
      </button>
    </nav>

    <iframe #iframeApp
      id="frame"
      title="iframe application"
      [src]="iframeSrc"
      width="100%"
      height="100%"
      (load)="onLoad(iframeApp)">
    </iframe>
  </div>
</div>